import { NgModule } from '@angular/core';
import { CurrencyInputModule } from '../../../../shared/currency-input/currency-input.module';
import { SharedModule } from '../../../../shared/shared.module';
import { ReconciliationDialogComponent } from './reconciliation-dialog.component';
import { BankReconciliationService } from '../../../../../services/accounting/bank-reconciliation.service';
import { LegfiDatePipeModule } from '../../../../../pipes/format/legfi-date.module';
import { LegfiCurrencyPipeModule } from '../../../../../pipes/format/legfi-currency.module';
import { StringValidatorsModule } from '../../../../../directives/validators/string/string-validators.module';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatMomentDateModule } from '@angular/material-moment-adapter';

@NgModule({
    imports: [
        SharedModule,
        CurrencyInputModule,
        LegfiDatePipeModule,
        LegfiCurrencyPipeModule,
        StringValidatorsModule,
        MatTableModule,
        MatPaginatorModule,
        MatIconModule,
        MatFormFieldModule,
        MatSelectModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatMenuModule,
        MatButtonModule,
    ],
    exports: [ReconciliationDialogComponent],
    declarations: [ReconciliationDialogComponent],
    providers: [
        BankReconciliationService,
    ],
})
export class ReconciliationDialogModule
{
}
